import { useState, useEffect } from "react";
import { toast } from "sonner";
import { ArrowUpRight, Loader2 } from "lucide-react";
import { Reveal, RevealLine } from "../lib/motion";
import { startCheckout, http } from "../lib/api";
import { PayPalButton } from "./PayPalButton";
import { track } from "../lib/track";

export const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    http.get("/products").then((r) => setProducts(r.data.items || [])).catch(() => {});
    track("product_view");
  }, []);

  const buy = async (lookup) => {
    setLoading(lookup);
    track("buy_click", { product: lookup });
    try {
      const { checkout_url } = await startCheckout(lookup);
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Impossibile avviare il pagamento. Riprova.");
      setLoading(null);
    }
  };

  if (!products.length) return null;

  return (
    <section id="prodotti" data-testid="products-section" className="py-24 sm:py-32 bg-[var(--paper-2)]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-2xl mb-16">
          <div className="overline mb-6">Executive Digital Tools</div>
          <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-[var(--ink)]">
            <RevealLine>Strumenti pronti</RevealLine>
            <RevealLine delay={0.08} className="italic text-[var(--petrol)]">per governare meglio.</RevealLine>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {products.map((p, i) => (
            <Reveal key={p.lookup_key} delay={i * 0.1} className="flex flex-col bg-white border border-[var(--line)] p-8 hover:border-[var(--petrol)] transition-[border-color] duration-500">
              <div className="text-xs uppercase tracking-[0.15em] text-[var(--accent)] mb-6">{p.subtitle}</div>
              <h3 className="font-serif text-2xl text-[var(--ink)] mb-3">{p.name}</h3>
              <p className="text-sm text-[var(--ink-soft)] leading-relaxed flex-1">{p.description}</p>
              <div className="mt-8 flex items-end justify-between">
                <div>
                  {p.launch && <div className="overline !text-[var(--gold)] mb-1">Launch Edition</div>}
                  <div className="flex items-baseline gap-2">
                    <span className="font-serif text-3xl text-[var(--petrol)]">{p.price}</span>
                    {p.regular && <span className="text-sm text-[var(--ink-soft)]">Regular price <span className="line-through">{p.regular}</span></span>}
                  </div>
                </div>
                <button
                  data-testid={`buy-${p.lookup_key}`}
                  onClick={() => buy(p.lookup_key)}
                  disabled={loading === p.lookup_key}
                  className="btn-fill inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.15em] border border-[var(--petrol)] text-[var(--petrol)] hover:text-white px-5 py-3 disabled:opacity-60"
                >
                  {loading === p.lookup_key ? <Loader2 size={14} className="animate-spin" /> : <>Acquista <ArrowUpRight size={14} strokeWidth={2} /></>}
                </button>
              </div>
              <div className="mt-4">
                <PayPalButton lookup_key={p.lookup_key} testid={`paypal-${p.lookup_key}`} />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
